import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import { Popover } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { MEDICATION_ACTIONS } from './utils'

const Legend = () => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const theme = useTheme()
  return (
    <Popover
      placement="bottomRight"
      overlayInnerStyle={{
        borderRadius: '9px',
        padding: '10px 16px'
      }}
      content={
        <LegendContent>
          {MEDICATION_ACTIONS.map((action) => (
            <LegendItemContainer key={action.code || action.translationKey}>
              <LegendCodeContainer>
                {action.icon || (
                  <LegendCode level={2}>{action.code}</LegendCode>
                )}
              </LegendCodeContainer>
              <Text>{t(action.translationKey)}</Text>
            </LegendItemContainer>
          ))}
        </LegendContent>
      }
    >
      <LegendContainer>
        <QuestionCircleOutlined
          style={{ fontSize: 16, color: theme.color.neutral.color4 }}
        />
        <StyledText level={2}>{t('LEGEND')}</StyledText>
      </LegendContainer>
    </Popover>
  )
}

const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

const LegendContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
  min-width: 300px;
`

const LegendItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const LegendCodeContainer = styled.div`
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LegendCode = styled(Text)`
  font-weight: 600;
  color: ${({ theme }) => theme.color.neutral.color3};
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

export default Legend
